import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { UIContext } from "../../contexts/UIContext";
import { APIContext } from "../../contexts/APIContext";
const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  > tbody > tr {
    background-color: rgb(32, 39, 49);
  }

  th {
    padding: 1em;
  }
  td {
    padding: 0.2em;
    padding-left: 0.2em;
    padding-right: 0.2em;
    width: ${(props) => props.width};
    height: 30px;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: black;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #818283;
  text-align: left;
`;
const TR = styled.tr`
  > td {
    background-color: ${(props) => (props.highlight ? "#db0a41" : "")};
    border-top: ${(props) =>
      props.dots ? "1px dashed white" : " 2px solid rgb(24, 29, 37)"};
  }
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-right: 0.5em;
  margin-left: 0.5em;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  margin-bottom: 10px;
  font-size: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const Centre = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  padding: 1%;
`;

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "rgb(32, 39, 49)"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 40px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;

const RowDiv = styled.div`
  display: flex;
  align-items: center;
`;

const OptionColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionRowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-items: space-evenly;
  margin-top: 10px;
`;

const MiniButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "rgb(14 18 25)"};
  padding: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const OptionButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "rgb(14 18 25)"};
  padding: 5px;
  box-sizing: border-box;
  width: 30%;
  border-radius: 4px;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.green ? "#000" : "#fff")};
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function Catapult({ game, previewGraphic }) {
  const [selectedPlayer, setSelectedPlayer] = useState();
  const [homeManager, setHomeManager] = useState();
  const [awayManager, setAwayManager] = useState();
  const [showSeasonStat, setShowSeasonStat] = useLocalStorage(
    "hyper-rugby-catapult-season",
    true
  );
  const [showTeam, setShowTeam] = useLocalStorage(
    "hyper-rugby-catapult-team",
    "both"
  );
  const [showPosition, setShowPosition] = useLocalStorage(
    "hyper-rugby-catapult-position",
    "both"
  );
  const { graphics } = useContext(GraphicsContext);
  const {
    catapultAPIUrl,
    catapultAPIKey,
    catapultAPIInterval,
    catapultData: data,
    setCatapultData,
  } = useContext(UIContext);
  const { getSquad } = useContext(APIContext);
  useEffect(() => {
    let interval;
    if (parseInt(catapultAPIInterval) > 0) {
      interval = setInterval(() => {
        getData();
      }, parseInt(catapultAPIInterval));

      getData();
    }
    return () => {
      clearInterval(interval);
    };
  }, [catapultAPIInterval]);

  useEffect(() => {
    if (game) {
      getSquad({
        teamId: game?.home_team?._id,
        seasonId: game.season?._id,
      }).then((data) => {
        setHomeManager(data.find((s) => s.type === "coach"));
      });
      getSquad({
        teamId: game?.away_team?._id,
        seasonId: game.season?._id,
      }).then((data) => {
        setAwayManager(data.find((s) => s.type === "coach"));
      });
    }
  }, [game]);

  function getData() {
    // fetch("/CatapultExample.json")
    //   .then((res) => res.json())
    //   .then((data) => {
    //     setData(data);
    //   });

    fetch(catapultAPIUrl, {
      headers: {
        authorization: "Bearer " + catapultAPIKey,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCatapultData(data);
      });
  }

  return (
    <Column>
      {data?.message && (
        <ActionPanel>
          <div style={{ fontSize: "5em" }}>
            {data?.message} - Check API key in config
          </div>
        </ActionPanel>
      )}
      {!data?.message && (
        <ActionPanel>
          <Column>
            <Table>
              <thead>
                <tr>
                  <TH>ID</TH>
                  <TH>Name</TH>
                  <TH>Distance Run</TH>
                  <TH>Top Speed</TH>
                  <TH>Work rate (m/min)</TH>
                  <TH>High Speed Efforts (m)</TH>
                  <TH>Heart rate (bpm)</TH>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data) &&
                  data
                    ?.filter(
                      (d) =>
                        game?.lineup?.home?.findIndex(
                          (l) => l?.squad?.proc_id === d?.jersey
                        ) > -1 || homeManager?.proc_id === d?.jersey
                    )
                    ?.map((player) => {
                      return (
                        <Row
                          manager={homeManager}
                          player={player}
                          graphics={graphics}
                          previewGraphic={previewGraphic}
                          game={game}
                          team={game?.home_team}
                        />
                      );
                    })}
              </tbody>
            </Table>
          </Column>
          <Centre>
            <OptionColumnDiv>
              {parseInt(catapultAPIInterval) === 0 && (
                <OptionButton
                  style={{ width: "100%", height: "100px" }}
                  onClick={() => {
                    getData();
                  }}
                >
                  Get Data
                </OptionButton>
              )}
            </OptionColumnDiv>
            <OptionColumnDiv>
              <OptionRowDiv>Season stat</OptionRowDiv>
              <OptionRowDiv>
                <OptionButton
                  green={showSeasonStat}
                  onClick={() => {
                    setShowSeasonStat(true);
                  }}
                >
                  On
                </OptionButton>
                <OptionButton
                  green={!showSeasonStat}
                  onClick={() => {
                    setShowSeasonStat(false);
                  }}
                >
                  Off
                </OptionButton>
              </OptionRowDiv>
            </OptionColumnDiv>
            <OptionColumnDiv>
              <OptionRowDiv>Team</OptionRowDiv>
              <OptionRowDiv>
                <OptionButton
                  green={showTeam === "both"}
                  onClick={() => {
                    setShowTeam("both");
                  }}
                >
                  Both
                </OptionButton>
                <OptionButton
                  green={showTeam === "home"}
                  onClick={() => {
                    setShowTeam("home");
                  }}
                >
                  Home
                </OptionButton>
                <OptionButton
                  green={showTeam === "away"}
                  onClick={() => {
                    setShowTeam("away");
                  }}
                >
                  Away
                </OptionButton>
              </OptionRowDiv>
            </OptionColumnDiv>
            <OptionColumnDiv>
              <OptionRowDiv>Position</OptionRowDiv>
              <OptionRowDiv>
                <OptionButton
                  green={showPosition === "both"}
                  onClick={() => {
                    setShowPosition("both");
                  }}
                >
                  Both
                </OptionButton>
                <OptionButton
                  green={showPosition === "forwards"}
                  onClick={() => {
                    setShowPosition("forwards");
                  }}
                >
                  Forwards
                </OptionButton>
                <OptionButton
                  green={showPosition === "backs"}
                  onClick={() => {
                    setShowPosition("backs");
                  }}
                >
                  Backs
                </OptionButton>
              </OptionRowDiv>
            </OptionColumnDiv>
            <TeamStat
              game={game}
              category={"Top Distance Run"}
              showTeam={showTeam}
              showPosition={showPosition}
              showSeasonStat={showSeasonStat}
              graphics={graphics}
              previewGraphic={previewGraphic}
              data={data}
            />

            <TeamStat
              game={game}
              category={"Top Speed"}
              showTeam={showTeam}
              showPosition={showPosition}
              showSeasonStat={showSeasonStat}
              graphics={graphics}
              previewGraphic={previewGraphic}
              data={data}
            />
            <TeamStat
              game={game}
              category={"Top Work rate"}
              showTeam={showTeam}
              showPosition={showPosition}
              showSeasonStat={showSeasonStat}
              graphics={graphics}
              previewGraphic={previewGraphic}
              data={data}
            />
            <TeamStat
              game={game}
              category={"High Speed Efforts"}
              showTeam={showTeam}
              showPosition={showPosition}
              showSeasonStat={showSeasonStat}
              graphics={graphics}
              previewGraphic={previewGraphic}
              data={data}
            />
          </Centre>
          <Column>
            <Table style={{ marginLeft: "10px" }}>
              <thead>
                <tr>
                  <TH>ID</TH>
                  <TH>Name</TH>
                  <TH>Distance Run (m)</TH>
                  <TH>Top Speed (km/h)</TH>
                  <TH>Work rate (m/min)</TH>
                  <TH>High Speed Efforts (m)</TH>
                  <TH>Heart rate (bpm)</TH>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data) &&
                  data
                    ?.filter(
                      (d) =>
                        game?.lineup?.away?.findIndex(
                          (l) => l?.squad?.proc_id === d?.jersey
                        ) > -1 || awayManager?.proc_id === d?.jersey
                    )
                    ?.map((player) => {
                      return (
                        <Row
                          manager={awayManager}
                          player={player}
                          graphics={graphics}
                          previewGraphic={previewGraphic}
                          game={game}
                          team={game?.away_team}
                        />
                      );
                    })}
              </tbody>
            </Table>
          </Column>
        </ActionPanel>
      )}
      {Array.isArray(data) &&
        data?.filter(
          (d) =>
            game?.lineup?.home?.findIndex(
              (l) => l?.squad?.proc_id === d?.jersey
            ) === -1 &&
            game?.lineup?.away?.findIndex(
              (l) => l?.squad?.proc_id === d?.jersey
            ) === -1
        )?.length > 0 && (
          <ActionPanel>
            <Column>
              Players Not Mapped{" "}
              <Table style={{ marginLeft: "10px" }}>
                <thead>
                  <tr>
                    <TH>ID</TH>
                    <TH>Name</TH>
                    <TH>Distance Run (m)</TH>
                    <TH>Top Speed (km/h)</TH>
                    <TH>Work rate (m/min)</TH>
                    <TH>High Speed Efforts (m)</TH>
                    <TH>Heart rate (bpm)</TH>
                  </tr>
                </thead>
                <tbody>
                  {data
                    ?.filter(
                      (d) =>
                        game?.lineup?.home?.findIndex(
                          (l) => l?.squad?.proc_id === d?.jersey
                        ) === -1 &&
                        game?.lineup?.away?.findIndex(
                          (l) => l?.squad?.proc_id === d?.jersey
                        ) === -1
                    )
                    ?.map((player) => {
                      return (
                        <Row
                          player={{
                            ...player,
                            squad: {
                              player: {
                                first_name: player?.athlete_first_name,
                                last_name: player?.athlete_last_name,
                              },
                            },
                          }}
                          graphics={graphics}
                          game={game}
                          team={game?.away_team}
                        />
                      );
                    })}
                </tbody>
              </Table>
            </Column>
          </ActionPanel>
        )}
    </Column>
  );
}

function Row({ previewGraphic, player, graphics, game, team, manager }) {
  let player_data = game?.lineup?.home?.find(
    (l) => l?.squad?.proc_id === player?.jersey
  );
  if (!player_data) {
    player_data = game?.lineup?.away?.find(
      (l) => l?.squad?.proc_id === player?.jersey
    );
  }
  if (!player_data) {
    if (manager?.proc_id === player?.jersey) {
      player_data = { squad: manager };
    }
  }

  player = { ...player_data, ...player };

  return (
    <TR>
      <td>{player?.jersey}</td>
      <td
        onClick={() => {
          if (previewGraphic) {
            previewGraphic("CATAPULTPLAYERCB", {
              player: player?.squad?.player,
              game,
              team,
              subline: "",
              stats: [
                {
                  name: "Top speed",
                  value: player?.max_velocity?.toFixed(1) + " km/h",
                },
                {
                  name: "High speed efforts",
                  value: player.high_speed_efforts?.toLocaleString("en") + "m",
                },
                {
                  name: "Distance run",
                  value:
                    parseInt(player.total_distance)?.toLocaleString("en") + "m",
                },
                {
                  name: "Work rate",
                  value:
                    (
                      player?.total_distance /
                      (player?.field_seconds / 60)
                    )?.toFixed(1) + " m/min",
                },
              ],

              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }
        }}
      >
        {player?.squad?.player?.first_name} {player?.squad?.player?.last_name}
      </td>
      <td>
        <RowDiv>
          {parseInt(player.total_distance)?.toLocaleString("en")}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  shirt_number: player?.squad?.shirt_number,
                  subtext:
                    parseInt(player.total_distance)?.toLocaleString("en") +
                    " " +
                    "Distance run",
                  team,
                  game,
                  category: "Distance run",
                  value:
                    parseInt(player.total_distance)?.toLocaleString("en") + "m",
                  type: "LT",
                });
              }}
            >
              LT
            </MiniButton>
          )}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  subtext:
                    player?.total_distance?.toFixed(1) + " " + "Distance run",
                  team,
                  game,
                  category: "Distance run",
                  value:
                    parseInt(player.total_distance)?.toLocaleString("en") + "m",
                  type: "BUG",
                });
              }}
            >
              BUG
            </MiniButton>
          )}
        </RowDiv>
      </td>
      <td>
        <RowDiv>
          {player?.max_velocity?.toFixed(1)}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player,
                  player: player?.squad?.player,
                  shirt_number: player?.squad?.shirt_number,
                  subtext:
                    (player?.max_velocity).toFixed(1) + " " + "Top speed",
                  team,
                  game,
                  category: "Top speed",
                  value: player?.max_velocity?.toFixed(1) + " km/h",
                  type: "LT",
                });
              }}
            >
              LT
            </MiniButton>
          )}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  subtext: player?.max_velocity?.toFixed(1) + " " + "Top speed",
                  team,
                  game,
                  category: "Top speed",
                  value: player?.max_velocity?.toFixed(1) + " km/h",
                  type: "BUG",
                });
              }}
            >
              BUG
            </MiniButton>
          )}
        </RowDiv>
      </td>
      <td>
        <RowDiv>
          {(player?.total_distance / (player?.field_seconds / 60))?.toFixed(1)}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  shirt_number: player?.squad?.shirt_number,
                  subtext:
                    (
                      player?.total_distance /
                      (player?.field_seconds / 60)
                    )?.toFixed(1) +
                    " m/min" +
                    "Work rate",
                  team,
                  game,
                  category: "Work rate",
                  value:
                    (
                      player?.total_distance /
                      (player?.field_seconds / 60)
                    )?.toFixed(1) + " m/min",
                  type: "LT",
                });
              }}
            >
              LT
            </MiniButton>
          )}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,

                  subtext:
                    (
                      player?.total_distance /
                      (player?.field_seconds / 60)
                    )?.toFixed(1) +
                    " m/min" +
                    "Work rate",
                  team,
                  game,
                  category: "Work rate",
                  value:
                    (
                      player?.total_distance /
                      (player?.field_seconds / 60)
                    )?.toFixed(1) + " m/min",
                  type: "BUG",
                });
              }}
            >
              BUG
            </MiniButton>
          )}
        </RowDiv>
      </td>
      <td>
        <RowDiv>
          {player?.high_speed_efforts?.toLocaleString("en")}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  shirt_number: player?.squad?.shirt_number,
                  subtext:
                    player?.high_speed_efforts?.toLocaleString("en") + "m",
                  team,
                  game,
                  category: "High speed efforts",
                  value: player?.high_speed_efforts?.toLocaleString("en") + "m",
                  type: "LT",
                });
              }}
            >
              LT
            </MiniButton>
          )}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  subtext:
                    player?.high_speed_efforts?.toLocaleString("en") + "m",
                  team,
                  game,
                  category: "High speed efforts",
                  value: player?.high_speed_efforts?.toLocaleString("en") + "m",
                  type: "BUG",
                });
              }}
            >
              BUG
            </MiniButton>
          )}
        </RowDiv>
      </td>
      <td>
        <RowDiv>
          {player?.heart_rate?.toFixed(0)}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  shirt_number: player?.squad?.shirt_number,
                  subtext:
                    player?.heart_rate?.toFixed(0) + " bpm" + "Heart rate",
                  team,
                  game,
                  category: "Heart rate",
                  value: player?.heart_rate?.toFixed(0) + " bpm",
                  type: "LT",
                });
              }}
            >
              LT
            </MiniButton>
          )}
          {previewGraphic && (
            <MiniButton
              onClick={() => {
                previewGraphic("CatapultPlayerStat", {
                  player: player?.squad?.player,
                  subtext:
                    player?.heart_rate?.toFixed(0) + " bpm" + "Heart rate",
                  team,
                  game,
                  category: "Heart rate",
                  value: player?.heart_rate?.toFixed(0) + " bpm",
                  type: "BUG",
                });
              }}
            >
              BUG
            </MiniButton>
          )}
        </RowDiv>
      </td>
    </TR>
  );
}

function TeamStat({
  game,
  category,
  showPosition,
  showTeam,
  showSeasonStat,
  graphics,
  data,
  previewGraphic,
  variable,
}) {
  return (
    <GraphicButton
      onClick={() => {
        let players = data
          ?.filter(
            (d) =>
              game?.lineup?.home?.findIndex(
                (l) => l?.squad?.proc_id === d?.jersey
              ) > -1 ||
              game?.lineup?.away?.findIndex(
                (l) => l?.squad?.proc_id === d?.jersey
              ) > -1
          )
          ?.sort((a, b) => {
            let a_stat = 0;
            let b_stat = 0;
            if (category === "High Speed Efforts") {
              a_stat = parseInt(a.high_speed_efforts);
              b_stat = parseInt(b.high_speed_efforts);
            } else if (category === "Top Distance Run") {
              a_stat = parseInt(a.total_distance);
              b_stat = parseInt(b.total_distance);
            } else if (category === "Top Speed") {
              a_stat = a?.max_velocity?.toFixed(1);
              b_stat = b?.max_velocity?.toFixed(1);
            } else if (category === "Top Work rate") {
              a_stat = (a?.total_distance / (a?.field_seconds / 60))?.toFixed(
                1
              );
              b_stat = (b?.total_distance / (b?.field_seconds / 60))?.toFixed(
                1
              );
            }

            return b_stat - a_stat;
          })
          ?.map((p) => {
            let player = game?.lineup?.home?.find(
              (l) => l?.squad?.proc_id === p?.jersey
            );
            if (!player) {
              player = game?.lineup?.away?.find(
                (l) => l?.squad?.proc_id === p?.jersey
              );
            }
            return { ...p, player: player };
          });

        if (showPosition === "backs") {
          players = players?.filter((p) => p?.player?.order <= 7);
        } else if (showPosition === "forwards") {
          players = players?.filter((p) => p?.player?.order > 7);
        }
        if (showTeam === "home") {
          players = players?.filter(
            (p) =>
              game?.lineup?.home?.findIndex(
                (l) => l?.squad?.proc_id === p?.jersey
              ) > -1
          );
        } else if (showTeam === "away") {
          players = players?.filter(
            (p) =>
              game?.lineup?.away?.findIndex(
                (l) => l?.squad?.proc_id === p?.jersey
              ) > -1
          );
        }
        if (showTeam === "both") {
          players = players?.slice(0, 5);
        } else {
          players = players?.slice(0, 3);
        }
        let subtitle = "";
        if (showTeam === "home") {
          subtitle =
            game?.home_team?.short_name +
            " top {top}"?.replace("{top}", Math.min(players?.length));
        } else if (showTeam === "away") {
          subtitle =
            game?.away_team?.short_name +
            " top {top}"?.replace("{top}", Math.min(players?.length));
        } else {
          subtitle = "Top {top}"?.replace("{top}", Math.min(players?.length));
        }

        subtitle +=
          showPosition === "backs"
            ? " backs"
            : showPosition === "forwards"
            ? " forwards"
            : "";

        previewGraphic("Catapult", {
          title: category,
          showSeasonStat,
          subline: subtitle,
          top: players?.length,
          total_players: 10,
          team:
            showTeam === "home"
              ? game?.home_team
              : showTeam
              ? game?.away_team
              : null,
          team_cb: showTeam === "both" ? false : true,
          seasonStatIndex:
            showPosition === "both" ? 7 : showPosition === "forwards" ? 8 : 9,
          players: players?.map((p) => {
            let player = game?.lineup?.home?.find(
              (l) => l?.squad?.proc_id === p?.jersey
            );
            if (!player) {
              player = game?.lineup?.away?.find(
                (l) => l?.squad?.proc_id === p?.jersey
              );
            }
            let stat = "";
            if (category === "High Speed Efforts") {
              stat = p.high_speed_efforts?.toLocaleString("en") + "m";
            } else if (category === "Top Distance Run") {
              stat = parseInt(p.total_distance)?.toLocaleString("en") + "m";
            } else if (category === "Top Speed") {
              stat = p?.max_velocity?.toFixed(1) + " km/h";
            } else if (category === "Top Work rate") {
              stat =
                (p?.total_distance / (p?.field_seconds / 60))?.toFixed(1) +
                " m/min";
            }
            return {
              ...player,
              stat,
              team: game?.lineup?.home?.find(
                (pl) => pl?.squad?.proc_id === p?.jersey
              )
                ? game?.home_team
                : game?.lineup?.away?.find(
                    (pl) => pl?.squad?.proc_id === p?.jersey
                  )
                ? game?.away_team
                : null,
            };
          }),
          push_up:
            graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
            graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
        });
      }}
    >
      {category}
    </GraphicButton>
  );
}
export default Catapult;
